<div class="repair-diagram repair-diagram-dialog" [ngClass]="{'rd-full-screen': isOpenFullScreen }">
  <!-- Repair Diagram Title -->
  <div class="repair-diagram-dialog-header flex-between-center">
    <p class="m-0 font-bold">
      <i class="fal fa-file-alt font-16 pr-2"></i>
      <span>{{serviceName}}</span>
    </p>

    <span>
      <span class="open-full-modal mr-3 pl-1 pr-1">
        <i class="fal {{isOpenFullScreen? 'fa-expand-wide' : 'fa-compress'}}" (click)="handleopenFullScreen()"></i>
      </span>
      <span class="close-modal">
        <i class="fal fa-times" (click)="handleClose()"></i>
      </span>

    </span>
  </div>

  <!-- Repair Diagram Body -->
  <div class="repair-diagram-dialog-body flex-column flex-start-start">
    <!-- Dialog tabs -->
    <div class="repair-dialog-tabs-wrapper flex-between-center width-100p">
      <div class="repair-dialog-tabs flex-start-center">
        <div class="repair-dialog-tab flex-start-center pointer" [ngClass]="{'active': selectedTab === 0}"
          (click)="handleTabChange(0)">
          <p class="tab-title mb-0">Components & Diagrams</p>
          <p class="tab-count mb-0">{{moduleCount?.diagrams}}</p>
        </div>

        <div class="repair-dialog-tab flex-start-center pointer" [ngClass]="{'active': selectedTab === 1}"
          (click)="handleTabChange(1)">
          <p class="tab-title mb-0">Specs</p>
          <p class="tab-count mb-0">{{moduleCount?.specs}}</p>
        </div>

        <div class="repair-dialog-tab flex-start-center pointer" [ngClass]="{'active': selectedTab === 2}"
          (click)="handleTabChange(2)">
          <p class="tab-title mb-0">Procedures</p>
          <p class="tab-count mb-0">{{moduleCount?.procedures}}</p>
        </div>

        <div class="repair-dialog-tab flex-start-center pointer" [ngClass]="{'active': selectedTab === 3}"
          (click)="handleTabChange(3)">
          <p class="tab-title mb-0">Wiring</p>
          <p class="tab-count mb-0">{{moduleCount?.wirings}}</p>
        </div>

        <div class="repair-dialog-tab flex-start-center pointer" [ngClass]="{'active': selectedTab === 4}"
          (click)="handleTabChange(4)">
          <p class="tab-title mb-0">Bulletins</p>
          <p class="tab-count mb-0">{{moduleCount?.bulletins}}</p>
        </div>
      </div>

      <div class="flex-end-center">
        <img src="../../../../assets/img/motor.png" alt="motor driven" class="motor-icon">
      </div>
    </div>

    <!-- Dialog Content - Components & Diagram -->
    <app-rd-component-diagram class="width-100p" *ngIf="selectedTab === 0" [isProcessing]="isProcessing"
      [vehicleId]="vehicleId" [locations]="locations" [illustrations]="illustrations" [options]="options">
    </app-rd-component-diagram>

    <!-- Dialog Content - Specs -->
    <app-rd-specs class="width-100p" *ngIf="selectedTab === 1" [isProcessing]="isProcessing" [vehicleId]="vehicleId"
      [specifications]="specifications" [fluids]="fluids" [options]="options"></app-rd-specs>

    <!-- Dialog Content - Procedures -->
    <app-rd-procedures class="width-100p" *ngIf="selectedTab === 2" [isProcessing]="isProcessing"
      [vehicleId]="vehicleId" [procedures]="procedures" [options]="options"></app-rd-procedures>

    <!-- Dialog Content - Wiring -->
    <app-rd-wirings class="width-100p" *ngIf="selectedTab === 3" [isProcessing]="isProcessing" [vehicleId]="vehicleId"
      [wirings]="wirings" [options]="options"></app-rd-wirings>

    <!-- Dialog Content - Bulletins -->
    <app-rd-bulletins class="width-100p" *ngIf="selectedTab === 4" [isProcessing]="isProcessing" [vehicleId]="vehicleId"
      [bulletins]="bulletins" [options]="options"></app-rd-bulletins>

  </div>
</div>
